module.exports = __webpack_public_path__ + "assets/img/basicsetting.81657dc8.svg";